import React from 'react';
import { ICapsuleBadgeFields } from '@/types/contentful';
import classNames from 'classnames';
import Image from 'next/image';

const CapsuleBadge: React.FC<ICapsuleBadgeFields> = ({
  capsuleText,
  capsuleColor,
  capsuleAvatar
}) => {
  return (
    <span
      className={classNames(
        `typography-title-5 inline-flex min-w-9 items-center justify-center gap-2 rounded-[40px] py-1 font-medium`,
        capsuleAvatar ? 'pl-1 pr-2' : 'px-2'
      )}
      style={capsuleColor ? { backgroundColor: capsuleColor } : undefined}
    >
      {capsuleAvatar && capsuleAvatar.fields?.file?.url && (
        <Image
          src={`https://${capsuleAvatar.fields.file.url}`}
          alt={capsuleAvatar.fields?.description || 'Avatar'}
          className="flex h-6 w-6 items-center justify-center rounded-full object-cover"
          width={24}
          height={24}
        />
      )}
      {capsuleText}
    </span>
  );
};

export default CapsuleBadge;
